var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPhone = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.911,
    height: 26.865,
    viewBox: "0 0 26.911 26.865",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M14.782,8.378a.79.79,0,0,1,0-1.578,6.454,6.454,0,0,1,6.464,6.462.79.79,0,1,1-1.578,0,4.891,4.891,0,0,0-4.886-4.884ZM22.44,5.6a10.226,10.226,0,0,0-7.249-3.011.79.79,0,1,0,0,1.578,8.7,8.7,0,0,1,8.7,8.7.79.79,0,1,0,1.578,0A10.226,10.226,0,0,0,22.44,5.6ZM11.457,10.154a2.566,2.566,0,0,0,0-3.625l-2.9-2.9a2.566,2.566,0,0,0-3.625,0l-1.4,1.38c-1.283,1.281-1.373,3.521-.242,6.3,1.022,2.569,5.423,7.418,7.946,9.941a.79.79,0,0,0,1.116-1.116C9.982,17.761,5.7,13.1,4.747,10.725a8.1,8.1,0,0,1-.672-2.912,2.322,2.322,0,0,1,.57-1.691L6.035,4.732a.988.988,0,0,1,1.394,0l2.9,2.9a.986.986,0,0,1,0,1.4L9.237,10.121a3.158,3.158,0,0,0,0,4.466l4.168,4.168a3.166,3.166,0,0,0,4.468,0l1.092-1.087a.983.983,0,0,1,1.394,0l2.9,2.9a.983.983,0,0,1,0,1.394L21.872,23.35c-.628.633-1.849.742-3.407.309A22.886,22.886,0,0,1,12.169,20a.791.791,0,0,0-.967,1.252,23.184,23.184,0,0,0,6.84,3.92,8.1,8.1,0,0,0,2.129.317,4.962,4.962,0,0,0,.607-.034,3.6,3.6,0,0,0,2.213-1l1.382-1.38a2.571,2.571,0,0,0,0-3.625l-2.9-2.9a2.566,2.566,0,0,0-3.625,0l-1.092,1.092a1.583,1.583,0,0,1-2.235,0l-4.163-4.166a1.58,1.58,0,0,1,0-2.233Z",
    transform: "translate(2.403 -3.016) rotate(11)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone.45d86533.svg";
export { ForwardRef as ReactComponent };